import { JsonObject, JsonProperty } from 'json2typescript';

import { LoanFamily } from './loan-family.model';

@JsonObject('Catalog')
export class Catalog {
  @JsonProperty('dureeList', [Number], true)
  public durations: number[] = [];

  @JsonProperty('quantiemeList', [Number], true)
  public quantiemes: number[] = [];

  @JsonProperty('familles', [LoanFamily], true)
  public families: LoanFamily[] = [];
}
